module.exports = __webpack_public_path__ + "img/cq.67434e38.png";